import { requestType, SUPPLIER_ENDPOINTS } from "../../constants/Variables";
import Api from "../index";

const createSupplierBasePackage = (params) => {
  return Api(SUPPLIER_ENDPOINTS.BASE_PACKAGE.CREATE, params, requestType.POST);
};
const getSupplierAllBasePackages = (params) => {
  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.supplierId) queryParams.append("supplierId", params.supplierId);
  if (params.status) queryParams.append("status", params.status);
  if (params.isVerified) queryParams.append("isVerified", params.isVerified);
  if (params.categoryId) queryParams.append("categoryId", params.categoryId);
  if (params.subCategoryId) queryParams.append("subCategoryId", params.subCategoryId);
  if (params.subSubCategoryId) queryParams.append("subSubCategoryId", params.subSubCategoryId);
  if (params.solutionType) queryParams.append("solutionType", params.solutionType);
  if (params.tags) queryParams.append("tags", params.tags);

  const finalUrl = queryParams.toString() ?
    `${SUPPLIER_ENDPOINTS.BASE_PACKAGE.GET_ALL}?${queryParams.toString()}` :
    `${SUPPLIER_ENDPOINTS.BASE_PACKAGE.GET_ALL}`;
  return Api(finalUrl, null, requestType.GET);
};

const getSupplierBasePackageById = (id) => {
  return Api(SUPPLIER_ENDPOINTS.BASE_PACKAGE.GET_BY_ID.replace(":id", id), null, requestType.GET);
};

const getSupplierBasePackageBySlug = (slug) => {
  return Api(SUPPLIER_ENDPOINTS.BASE_PACKAGE.GET_BY_SLUG.replace(":slug", slug), null, requestType.GET);
};

const updateSupplierBasePackage = (id, params) => {
  return Api(SUPPLIER_ENDPOINTS.BASE_PACKAGE.UPDATE.replace(":id", id), params, requestType.PUT);
};

const deleteSupplierBasePackage = (id) => {
  return Api(SUPPLIER_ENDPOINTS.BASE_PACKAGE.DELETE.replace(":id", id), null, requestType.DELETE);
};

const generateSupplierBasePackageSpecification = (params) => {
  return Api(SUPPLIER_ENDPOINTS.BASE_PACKAGE.GENERATE_SPECIFICATION, params, requestType.POST);
};

const exportBasePackages = (query) => {
  const queryParams = new URLSearchParams();
  if (query.supplierId) queryParams.append("supplierId", query.supplierId);
  const finalUrl = queryParams.toString()
    ? `${SUPPLIER_ENDPOINTS.BASE_PACKAGE.EXPORT_BASE_PACKAGES}?${queryParams.toString()}`
    : `${SUPPLIER_ENDPOINTS.BASE_PACKAGE.EXPORT_BASE_PACKAGES}`;
  return Api(finalUrl, null, requestType.GET);
};


export {
  createSupplierBasePackage, deleteSupplierBasePackage,
  generateSupplierBasePackageSpecification, getSupplierAllBasePackages,
  getSupplierBasePackageById,
  getSupplierBasePackageBySlug,
  updateSupplierBasePackage,
  exportBasePackages,
};

